/*
 * @Author: LiuLiXue QQ:136890965
 * @Date: 2017-12-25 14:56:42
 * @Last Modified by: aLeng
 * @Last Modified time: 2018-06-20 09:42:35
 */
//用户管理页面

<template>
  <section class="user-wrap">
    <div class="header-wrap">
      <title-btn  title="后台用户管理" btnTitle="+ 添加用户" v-on:click="showEditBox('添加用户')"/>
    </div>
    <!-- 内容区域 -->
    <div class="content-wrap">
      <div class="content-list" v-for="(item,index) in listCmsUser" :key="index">
        <div class="account-wrap">
          <span class="account" v-text="item.loginName"></span>
        </div>
        <div class="name-wrap">
          <span class="name" v-text="item.fullname"></span>
        </div>
        <div class="info-wrap">
          <div class="info-wrap__top">
            <div class="info">
                <div class="info-detail">
                  <span  class="info-title">手机号:</span>
                  <span class="info-content" v-text="item.mobile"></span>
                </div>
            </div>
            <div class="info top-left">
                <div class="info-detail">
                  <span  class="info-title">角色:</span>
                  <span class="info-content" v-text="item.rolename"></span>
                </div>
            </div>
          </div>
          <div class="info-wrap__bottom">
            <div class="info">
                <div class="info-detail">
                  <span  class="info-title">上次登录时间:</span>
                  <span class="info-content" v-if="item.lastLoginTime">{{item.lastLoginTime|to-date}}</span>
                </div>
            </div>
          </div>
        </div>
        <div class="button-wrap">
          <div class="btn">
           <el-button type="text" @click="showEditBox('编辑用户',item,true)">编辑用户</el-button>
          </div>
          <div class="btn">
           <el-button type="text" @click="showPreBox(item.userId,item.roleId)" style="color: #aaa;">修改权限</el-button>
          </div>
          <div class="btn">
           <el-button @click="deleteUser(item.userId,item.status)" type="text" style="color: #f03745;">删除用户</el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 页码 -->
    <div class="pageWrap">
      <el-pagination
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="total"
        @current-change="clickPage"
        >
      </el-pagination>
    </div>
    <!-- 编辑/添加用户弹框 -->
    <edit-user
      :visible="isShowEdit"
      :title="editBoxTitle"
      :userInfo="userInfo"
      :listRole="listRole"
      v-on:noClosed="isShowEdit = true"
      v-on:cancel="cancelEdit"
      v-on:sure="sureEdit($event)"/>
    <!-- 修改权限弹出框 -->
    <!-- :data="treeData" -->
      <pre-box :visible="isShowPre"
      :data="data"
      :showForm="showForm"
      :defaultChecked="defaultChecked"
      v-on:cancel="isShowPre = false"
      v-on:noClosed="isShowPre = true"
      v-on:sure="surePre($event)"/>
  </section>
</template>

<script>
import TitleBtn from "@/components/TitleButton";
import EditUser from "./EditBox";
import PreBox from "./UserPer";
import { getCookie } from "@/utils/common";
import {
  getUserList,
  addCmsUser,
  deleteUser,
  setUserPre,
  getMenu
} from "@/api/permission/userManage";
import { getRoleList, getPremiss } from "@/api/permission/roleManage";
import { toTreeData } from "./toTreeData";
export default {
  name: "userManage",
  components: {
    TitleBtn,
    EditUser,
    PreBox
  },
  data() {
    return {
      isShowEdit: false,
      isShowPre: false,
      showForm: false,
      isEdit: false, //是否编辑用户
      editBoxTitle: "添加用户",
      defaultChecked: [], //用户权限列表默认需要选择
      initChecked: [], //初始权限未做修改禁止修改
      currentPage: 1,
      pageSize: 10,
      total: 0,
      msg: "",
      userId: "", //用户id
      listCmsUser: [],
      listRole: [], //角色列表
      userInfo: {},
      roleId: "", //角色id
      data: [],
      listFirstMenu: []
    };
  },
  created() {
    this._getUserList();
    this._getRoleList();
  },
  methods: {
    cancelEdit() {
      this.userInfo = {};
      this.isShowEdit = false;
    },
    deleteUser(id, status) {
      this.$confirm("是否删除此用户", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          if (1 === status) {
            deleteUser(id)
              .then(res => {
                if ("success" === res.data.msg) {
                  this._getUserList(this.currentPage);
                  this.$message({
                    type: "success",
                    message: "删除成功!"
                  });
                }
              })
              .catch(error => {
                let msg = "请求出错！";
                if (error.response.data) {
                  msg = error.response.data.msg || "请求出错";
                }

                this.$message({
                  type: "warning",
                  message: msg
                });
              });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 显示编辑/添加弹框
    showEditBox(title = "添加用户", userInfo = {}, isEdit = false) {
      this.editBoxTitle = title;
      this.isShowEdit = true;
      this.isEdit = isEdit;
      this.userInfo = userInfo;
    },
    sureEdit(form) {

      this._addUser(form);
    },
    // 显示修改权限弹框
    showPreBox(userId = "", roleId = "") {
      this.userId = userId;
      this.roleId = roleId;
      Promise.all([this._getPremiss(), this._getMenu()])
        .then(res => {
          let all = {};
          const listFirstMenu = JSON.parse(getCookie("listFirstMenu"));
          const listSecondMenu = JSON.parse(getCookie("listsecondMenu"));
          const listThreeMenu = JSON.parse(getCookie("listThreeMenu"));
          const data = [...listFirstMenu, ...listSecondMenu, ...listThreeMenu];
          all["initData"] = res[0];
          all["checkedData"] = res[1];
          all["allData"] = data;
          return all;
          // this.data = toTreeData(data, this.initChecked);
        })
        .then(res => {
          let { initData, checkedData, allData } = res;
          this.defaultChecked = checkedData;
          this.initChecked = initData;
          this.data = toTreeData(allData, initData);
        })
        .then(() => {
          this.isShowPre = true;
        })
        .catch(error => {
          this._notify("请求异常,发生错误");
        });
    },
    // 获取最初定义的权限列表此列表不可更改
    _getPremiss() {
      return getPremiss(this.roleId).then(res => {
        const { listFirstMenu, listsecondMenu, listThreeMenu } = res.data;
        const data = [...listFirstMenu, ...listsecondMenu, ...listThreeMenu];
        // let len = data.length;
        // let initCheckIds = new Set();
        let len = data.length,
          fLen = listFirstMenu.length,
          tLen = listThreeMenu.length,
          sLen = listsecondMenu.length,
          initCheckIds = [],
          firstIds = [],
          secondIds = [],
          threeIds = [];
        for (let f = 0; f < fLen; f++) {
          firstIds.push(listFirstMenu[f].id);
        }
        firstIds = [...new Set(firstIds)];
        for (let s = 0; s < sLen; s++) {
          let pId = listsecondMenu[s].parentId;
          let idx = firstIds.indexOf(pId);
          if (-1 != idx) {
            firstIds[idx] = 0;
          }
          secondIds.push(listsecondMenu[s].id);
        }
        secondIds = [...new Set(secondIds)];
        for (let t = 0; t < tLen; t++) {
          let pId = listThreeMenu[t].parentId;
          threeIds.push(listThreeMenu[t].id);
          let idx = secondIds.indexOf(pId);
          if (-1 != idx) {
            secondIds[idx] = 0;
          }
        }
        initCheckIds = initCheckIds.concat(firstIds, secondIds, threeIds);
        initCheckIds.push(1);
        initCheckIds = new Set(initCheckIds);
        return [...initCheckIds];
      });
    },
    // 获取用户自定义的修改过的权限
    _getMenu() {
      return getMenu(this.userId).then(res => {
        if ("success" === res.data.msg) {
          const { listFirstMenu, listsecondMenu, listThreeMenu } = res.data;
          const data = [...listFirstMenu, ...listsecondMenu, ...listThreeMenu];
          let len = data.length,
            fLen = listFirstMenu.length,
            tLen = listThreeMenu.length,
            sLen = listsecondMenu.length,
            checkIds = [],
            firstIds = [],
            secondIds = [],
            threeIds = [];
          for (let f = 0; f < fLen; f++) {
            firstIds.push(listFirstMenu[f].id);
          }
          firstIds = [...new Set(firstIds)];
          for (let s = 0; s < sLen; s++) {
            let pId = listsecondMenu[s].parentId;
            let idx = firstIds.indexOf(pId);
            if (-1 != idx) {
              firstIds[idx] = 0;
            }
            secondIds.push(listsecondMenu[s].id);
          }
          secondIds = [...new Set(secondIds)];
          for (let t = 0; t < tLen; t++) {
            let pId = listThreeMenu[t].parentId;
            threeIds.push(listThreeMenu[t].id);
            let idx = secondIds.indexOf(pId);
            if (-1 != idx) {
              secondIds[idx] = 0;
            }
          }
          checkIds = checkIds.concat(firstIds, secondIds, threeIds);
          checkIds.push(1);
          checkIds = new Set(checkIds);
          return [...checkIds];
        }
      });
    },
    surePre(ids) {
      let idsLen = ids.length,
        initLen = this.initChecked.length;
      let addPre = [];
      for (let i = 0; i < idsLen; i++) {
        let num = ids[i];
        this.initChecked.indexOf(num) === -1 ? addPre.push(num) : 0;
      }
      let newAdd = addPre.join(",");
      setUserPre({ userId: this.userId, menuId: newAdd })
        .then(res => {
          if ("success" == res.data.msg) {
            this._notify("修改成功");
          }
        })
        .catch(error => {
          let { msg } = error.response.data;
          if (!msg) {
            msg = "发生错误请重试!";
          }
          this.$notify({
            title: "提示",
            message: msg,
            type: "warning",
            duration: 3000
          });
        })
        .finally(() => {
          this.isShowPre = false;
        });
    },
    // 点击页码
    clickPage(val) {
      this.currentPage = val;
      this._getUserList();
    },
    // 获取所有角色列表
    _getRoleList() {
      getRoleList(1, 100).then(res => {
        if (res.data.listRole.length != 0) {
          this.listRole = res.data.listRole;
        }
      });
    },
    // 获取用户列表
    _getUserList() {
      getUserList(this.currentPage, this.pageSize)
        .then(res => {
          console.log(res);
          if (res.data.listCmsUser.length != 0) {
            for (let prop in res.data) {
              this[prop] = res.data[prop];
            }
          }
        })
        .catch(error => {});
    },
    // 增加用户
    _addUser(form) {
      addCmsUser(form, this.isEdit)
        .then(res => {
          if ("success" === res.data.msg) {
            let msg = "添加成功";
            if (this.isEdit) {
              msg = "编辑成功!";
            } else {
              this.currentPage = 1;
            }
            this._notify(msg);
            this._getUserList();
            this.isShowEdit = false;
          }
        })
        .catch(error => {
          let { msg } = error.response.data;
          if (!msg) {
            msg = "发生错误请重试!";
          }
          this.$notify({
            title: "提示",
            message: msg,
            type: "warning",
            duration: 3000
          });
        });
    },
    //通知框
    _notify(message = "提示", type = "success") {
      this.$notify({
        title: "提示",
        message,
        type,
        duration: 3000
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.user-wrap {
  width: 97%;
  min-height: 100%;
  background-color: #ecf0f0;
  margin: 20px 0;
  padding: 0 20px;
}
.content-wrap {
  /*margin: 20px 0;*/
  /*padding: 0 20px;*/
}
.content-list {
  $width: 20%;
  %_center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  %_com {
    width: $width;
    @extend %_center;
  }
  width: 100%;
  height: 104px;
  display: flex;
  margin-bottom: 10px;
  justify-content: flex-start;
  border-radius: 10px;
  background-color: #fff;
  .account-wrap {
    @extend %_com;
    .account {
      font-size: 16px;
      color: #009cec;
      font-weight: bold;
    }
  }
  .name-wrap {
    @extend %_com;
    .name {
      font-size: 14px;
      color: #52616f;
    }
  }
  .info-wrap {
    //
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    margin: 20px 0;
    border-right: 1px solid #ddd;
    .top-left {
      margin-left: 40px;
    }
    .info {
      display: inline-block;
      &-detail {
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
      &-title {
        font-size: 14px;
        color: #b0b7bd;
      }
      &-content {
        font-size: 14px;
        color: #52616f;
      }
    }
  }
  .button-wrap {
    width: 20%;
    display: flex;
    flex-direction: column;
    margin: 10px 0;
    .btn {
      flex: 1;
      @extend %_center;
      .el-button {
        padding: 8px 20px;
      }
    }
  }
}
.pageWrap {
  margin-top: 20px;
  .el-pagination {
    text-align: center;
  }
}
</style>





// WEBPACK FOOTER //
// src/pages/permissions/UserManage.vue